import { render } from "./LaunchComponent.vue?vue&type=template&id=4badff53&scoped=true"
import script from "./LaunchComponent.vue?vue&type=script&lang=js"
export * from "./LaunchComponent.vue?vue&type=script&lang=js"

import "./LaunchComponent.vue?vue&type=style&index=0&id=4badff53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4badff53"]])

export default __exports__